const parseValidationError = (validationError) => {
  let error = validationError.critical ? "critical" : null;
  let errorMessage = validationError.critical;
  if (!error) {
    error = validationError.error ? "danger" : null;
    errorMessage = validationError.error;
  }
  if (!error) {
    error = validationError.warning ? "warning" : null;
    errorMessage = validationError.warning;
  }

  return { error, errorMessage };
};

export default parseValidationError;
